import React, {useState, useEffect, useContext} from "react";
import _ from "lodash"

import db from "../../services/query";
import {YearContext} from "../../contexts/yearContext";

import MainTitle from "../common/MainTitle";
import MainButton from "../common/MainButton";
import ListStats from "../common/ListStats";
import EditButton from "../common/EditButton";
import TableMainSearch from "../common/MainSearch";

import StudentsList from "./StudentsResultList";

import lbl from "../../data/Labels.json";
import {PopUpContext} from "../../contexts/popUpContext";
import StudentResultOptionsButtons from "./StudentResultOptionsButtons";

const StudentsResults = (props) => {
    const [data, setData] = useState([]);
    const [unChangedData, setUnChangedData] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [query, setQuery] = useState("");

    const {cid, sid} = props.match.params;

    const {entryYear} = useContext(YearContext);

    const {togglePopUp} = useContext(PopUpContext);

    const handleSaveClick = (editMode) => {

        // if we are switching to edit mode do nothing
        if (editMode) {
            setEditMode(editMode);
            return;
        }

        const {cid, sid} = props.match.params;
        let changedRows = [];

        // only update changed rows
        for (let i = 0; i < data.data.length; i++) {
            if (!_.isEqual(data.data[i], unChangedData.data[i])) {
                changedRows.push(
                    _.pick(data.data[i], 'id', 'mid_term', 'homework', 'class_activity', 'final', 'last_modified_by')
                )
            }
        }
        // if some rows are changed show popUp
        if(changedRows.length > 0) {
            togglePopUp({
                form: "student-result-update-form",
                subjectId: sid,
                classId: cid,
                results: changedRows,
                callback: ({status}) => {
                    // reload only on success
                    if (status && status == 200) {
                        setEditMode(editMode);
                        requestData();
                    }
                },
            })
        } else {
            setEditMode(editMode);
        }
    }

    useEffect(async () => {
        const ac = new AbortController();
        requestData({entry_year_id: entryYear});
        return () => ac.abort();
    }, [entryYear]);

    const requestData = async (p = new Object()) => {
        try {
            const {entry_year_id} = p;

            let query = `results/classes/${cid}/${sid}?`;

            if (entry_year_id) query += `&entryYearId=${entry_year_id}`;

            await db.getAll(query).then(({data}) => {
                setData(data);
                setUnChangedData(_.cloneDeep(data));
            });
        } catch ({response}) {
            setData(response);
        }
    };

    const getSummary = () => {
        const summary = {...data?.summary}

        // hide extra fields from summary section
        const extraFields = ["faculty_name", "class_desc", "class_status_id", "entry_year"]
        for (const field of extraFields) {
            delete summary[field];
        }
        return summary;
    }

    return (
        <div className="main-content">
            <div className="main-content-header">
                <div className="right-content">
                    <MainButton title={lbl.PrevPage} type={"back"}/>
                    <MainTitle title={data?.summary?.title}/>
                </div>
                <div className="center-content">
                    <TableMainSearch setQuery={setQuery}/>
                </div>
                <div className="left-content" style={{display: "flex", flexDirection: "row-reverse",}}>
                    <StudentResultOptionsButtons classId={cid} subjectId={sid} entryYear={entryYear}/>
                    <EditButton setEditMode={handleSaveClick} editMode={editMode}/>
                </div>
            </div>
            <div className="main-content-body">
                <ListStats stats={getSummary()}/>
                <StudentsList data={data.data} editMode={editMode} query={query}/>
            </div>
        </div>
    );
};

export default StudentsResults;
